import { useQuery, useMutation } from '@apollo/client';
import { Link, useNavigate } from "react-router-dom";

import { Icon, Header, Message } from 'semantic-ui-react'

import { JoyyaHeader } from '../../../../components/JoyyaHeader';
import { ClassListItem } from "../../../../components/teacher/ClassListItem";

import { GET_CLASSES } from '../data/GET_CLASSES';
import { CREATE_CLASSRECORD } from '../data/mutation_CREATE_CLASSRECORD';

import styles from './TeacherClassRecord.module.css'

import { useBlocks } from '../../../../hooks/useBlocks';

const scoreToLetterGrade = (score: number) => {
    if (score == null || score == 0) return '?';
    if (score >= 90) return 'AA';
    if (score >= 80) return 'A+';
    if (score >= 60) return 'A';
    if (score >= 45) return 'B+';
    if (score >= 35) return 'B';
    if (score >= 25) return 'C';
    return 'D';
}

const TeacherAllRecords = () => {
    const navigate = useNavigate();
    const [createRecord] = useMutation(CREATE_CLASSRECORD);

    const { currentBlockFilter, loading: blocksLoading } = useBlocks();

    const { loading, data: classesData, refetch } = useQuery(GET_CLASSES, {
        skip: blocksLoading || !currentBlockFilter,
        variables: {
            search: '',
            filters: currentBlockFilter
        }
    });

    return (
        <>
            <JoyyaHeader />
            <div className='mobile-frame'>
                <Header as='h2'>
                    <span className={styles.header}>
                        <Icon name='arrow left' className={styles.pointer} onClick={() => navigate(-1)} />
                        All records by class
                    </span>
                </Header>
                {loading && (<Message>Loading records...</Message>)}
                {classesData != null && classesData.classes != null && classesData.classes.length > 0 && (classesData.classes.map((item: any) => (
                    <>
                        <Link to={`/classes/${item.id}/records`} style={{ textDecoration: 'none', color: 'inherit' }} key={item.id + '_' + item.time}>
                            <ClassListItem
                                time={item.name}
                                program={'SR'}
                                classLabel={item.classLabel}
                                level={item.level}
                                communityCode={item.SKU.split('-')[0]}
                            />
                        </Link>
                        {/* For each person make a little record card with their scores and completion status */}

                        <div style={{ flexWrap: 'wrap', display: 'flex', gap: '10px' }}>
                            {item.classRecords && item.classRecords.length === 0 && (
                                <>
                                    {item.participants.length === 0 ? (
                                        <p>No records available for this block. No participants</p>
                                    ) : (
                                        <button onClick={async () => {
                                            await Promise.all(
                                                item.participants.map((participant: any) => {
                                                    return createRecord({
                                                        variables: {
                                                            studentUserId: Number(participant.id),
                                                            courseId: Number(item.id),
                                                        }
                                                    });
                                                })
                                            )
                                            await refetch()
                                        }}>
                                            Create records for {item.participants.length} participants
                                        </button>

                                    )}
                                </>
                            )}
                            {item.classRecords && item.classRecords.length > 0 && item.classRecords.map((record: any) => {
                                return record.completionStatus === 'DROPPED' ?
                                    (
                                        <div key={record.id} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', marginBottom: '10px', maxWidth: '224px', backgroundColor: '#f8d7da' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                {record.user.photoUrl ? (
                                                    <img src={record.user.photoUrl} alt={`${record.user.name}'s profile`} style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
                                                ) : (
                                                    <div style={{ width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#ccc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <span style={{ color: '#fff', fontSize: '24px' }}>{record.user.name.charAt(0)}</span>
                                                    </div>
                                                )}
                                                <div>{record.user.name} ({record.user.identifier})</div>
                                            </div>
                                            <br />
                                            {record.teacherComment && (
                                                <div><strong>Teacher Comment:</strong> {record.teacherComment}</div>
                                            )}
                                        </div>
                                    ) : (
                                        <div key={record.id} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', marginBottom: '10px', maxWidth: '224px' }}>
                                            <div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    {record.user.photoUrl ? (
                                                        <img src={record.user.photoUrl} alt={`${record.user.name}'s profile`} style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
                                                    ) : (
                                                        <div style={{ width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#ccc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <span style={{ color: '#fff', fontSize: '24px' }}>{record.user.name.charAt(0)}</span>
                                                        </div>
                                                    )}
                                                    <div>{record.user.name} ({record.user.identifier})</div>
                                                </div>
                                            </div>
                                            <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}><strong>Capacity</strong></td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.endCapacityScore}</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{scoreToLetterGrade(record.endCapacityScore)}</td>
                                                    </tr>
                                                    {/* Yellow */}
                                                    <tr style={{ backgroundColor: '#fff3cd' }}>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}><strong>Confidence</strong></td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.confidenceScore}</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{scoreToLetterGrade(record.confidenceScore)}</td>
                                                    </tr>
                                                    {/* Teal */}
                                                    <tr style={{ backgroundColor: '#d1ecf1' }}>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}><strong>Connection</strong></td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.connectionScore}</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{scoreToLetterGrade(record.connectionScore)}</td>
                                                    </tr>
                                                    {/* Light red */}
                                                    <tr style={{ backgroundColor: '#f8d7da' }}>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}><strong>Contribution</strong></td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.contributionScore}</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{scoreToLetterGrade(record.contributionScore)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}><strong>Attendance</strong></td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{record.attendanceScore}</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{scoreToLetterGrade(record.attendanceScore)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}><strong>Overall</strong></td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{
                                                            (record.connectionScore + record.contributionScore + record.endCapacityScore + record.confidenceScore + record.attendanceScore) / 5
                                                        }</td>
                                                        <td style={{ border: '1px solid #ddd', padding: '8px' }}>{scoreToLetterGrade(
                                                                Math.round((record.connectionScore + record.contributionScore + record.endCapacityScore + record.confidenceScore + record.attendanceScore) / 5)
                                                        )}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <br />
                                            <div><strong>Teacher Comment:</strong> {record.teacherComment}</div>
                                        </div>
                                    )
                            }

                            )}
                        </div>
                    </>
                )))}
            </div>
        </>
    );
}

export { TeacherAllRecords }
